import { BotIcon, CalendarXIcon, PhoneForwardedIcon, XCircleIcon } from 'lucide-react';

import { ActionAccordionCard } from '@/app/(app)/voice-agent/action-accordion-card';
import { useVoiceSettingsCtx } from '@/app/(app)/voice-agent/provider';
import { EscalationCallout } from '@/app/(app)/voice-agent/tab-routing';
import { ToggleButton } from '@/components/atoms/toggle-button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export function ActionCancelAppointment() {
  const {
    settings: { appointments },
    onChange: onSettingsChange,
  } = useVoiceSettingsCtx();

  const handling = appointments.cancel.handling;

  const onChange = (v: Partial<(typeof appointments)['cancel']>) => {
    onSettingsChange({ appointments: { ...appointments, cancel: { ...appointments.cancel, ...v } } });
  };

  return (
    <ActionAccordionCard
      icon={<CalendarXIcon className='size-4' />}
      title='Cancel Appointment'
      description="Agent's ability to cancel existing appointments."
    >
      <div className='flex flex-col gap-3'>
        <Label className='px-1'>How should this action be handled?</Label>
        <div className='grid grid-cols-3 gap-2'>
          <ToggleButton
            selected={handling === 'ENABLED'}
            toggle={() => onChange({ handling: 'ENABLED' })}
            layout='vertical'
            className='py-4'
          >
            <BotIcon className='size-4' />
            Agent can handle
          </ToggleButton>
          <ToggleButton
            selected={handling === 'NOTIFY_REPRESENTATIVE'}
            toggle={() => onChange({ handling: 'NOTIFY_REPRESENTATIVE' })}
            layout='vertical'
            className='py-4'
          >
            <PhoneForwardedIcon className='size-4' />
            Notify Representative
          </ToggleButton>
          <ToggleButton
            selected={handling === 'DISABLED'}
            toggle={() => onChange({ handling: 'DISABLED' })}
            layout='vertical'
            className='py-4'
          >
            <XCircleIcon className='size-4' />
            Do Nothing
          </ToggleButton>
        </div>
        {handling === 'ENABLED' && (
          <div className='mt-3 space-y-2'>
            <Label className='px-1'>Cancellation Script</Label>
            <Textarea
              placeholder='Enter custom cancellation script...'
              value={appointments.cancel.script_enabled ?? ''}
              onChange={(e) => onChange({ script_enabled: e.target.value })}
              className='min-h-[100px]'
            />
          </div>
        )}
        {handling === 'NOTIFY_REPRESENTATIVE' && (
          <div className='mt-3'>
            <EscalationCallout />
            <div className='mt-4 space-y-2'>
              <Label className='px-1'>Script</Label>
              <Textarea
                placeholder='Enter custom notification script...'
                value={appointments.cancel.script_notify ?? ''}
                onChange={(e) => onChange({ script_notify: e.target.value })}
                className='min-h-[100px]'
              />
            </div>
          </div>
        )}
      </div>
    </ActionAccordionCard>
  );
}
